"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReEnrichStrategyNode = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../__generated__/graphql");
const constants_1 = require("./constants");
const create_ticket_sequence_for_catalog_hook_1 = require("./create-ticket-sequence-for-catalog.hook");
const get_tree_nodes_utils_1 = require("../../product-tree-nodes/get-tree-nodes.utils");
const context_1 = require("../../../context");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const useReEnrichStrategyNode = () => {
    const { createTicketSequenceForCatalog, data } = (0, create_ticket_sequence_for_catalog_hook_1.useCreateTicketSequenceForCatalog)();
    const { addOptimisticReEnrich, clearOptimisticReEnrich } = (0, context_1.useCatalogActivityProgressContext)();
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const catalogTags = (0, store_1.useSelectedCatalogTags)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const createReEnrichCatalogTicket = (0, react_1.useCallback)((_a) => __awaiter(void 0, void 0, void 0, function* () {
        var { catalogId, productTreeNodeId, selectedTreeNodePath, onCompleted, onError } = _a, options = __rest(_a, ["catalogId", "productTreeNodeId", "selectedTreeNodePath", "onCompleted", "onError"]);
        setIsLoading(true);
        // Extract ancestor IDs from path for optimistic state
        const ancestorIds = (0, get_tree_nodes_utils_1.getParentTreeNodeIdsFromPath)(selectedTreeNodePath);
        // Add optimistic re-enrich state immediately for 0ms feedback
        addOptimisticReEnrich(productTreeNodeId, ancestorIds);
        const productTreeNodeLink = { reference: productTreeNodeId, linkType: graphql_1.LinkType.Mention };
        try {
            const response = yield createTicketSequenceForCatalog({
                catalogId,
                tags: catalogTags,
                tickets: constants_1.TICKETS_FOR_RE_ENRICH_TREE_NODE,
                options: {
                    additionalLinks: [productTreeNodeLink],
                },
                variables: { projectId: options.variables.projectId },
                onCompleted,
                onError: (error) => {
                    // Clear optimistic state on error
                    clearOptimisticReEnrich(productTreeNodeId);
                    addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
                    onError === null || onError === void 0 ? void 0 : onError(error);
                },
            });
            setIsLoading(false);
            return response;
        }
        catch (error) {
            // Clear optimistic state if mutation throws
            clearOptimisticReEnrich(productTreeNodeId);
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            setIsLoading(false);
            throw error;
        }
    }), [
        addOptimisticReEnrich,
        createTicketSequenceForCatalog,
        catalogTags,
        clearOptimisticReEnrich,
        addError,
        t,
    ]);
    return Object.assign(Object.assign({}, data), { createReEnrichCatalogTicket, loading: isLoading });
};
exports.useReEnrichStrategyNode = useReEnrichStrategyNode;
exports.default = exports.useReEnrichStrategyNode;
